import { render, staticRenderFns } from "./editmodal.vue.html?vue&type=template&id=3d4e9014"
import script from "./editmodal.controller.ts?vue&type=script&lang=js&external"
export * from "./editmodal.controller.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports